module.exports = __webpack_public_path__ + "bin/946161fbcd650970026bc6f97183859e.jpg";